/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientBirthday/view.blocks to change it.
import MaskedInput from 'DesignSystem/MaskedInput/index'
import PreviousQuestion from './PreviousQuestion/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import Status from './Status/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function PatientBirthday({
  children,
  viewPath = "/App/Form/Data/ProvideData/PatientBirthday",
  onChange,
  onSubmit,
  value
  
}) {
  return (<React.Fragment
>
<div
  data-testid="PatientBirthday.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="PatientBirthday.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PreviousQuestion
  viewPath={`${viewPath}/PreviousQuestion`}
/>
<Question
  viewPath={`${viewPath}/Question`}
 marginBottom={0}
 marginTop={4}
 text="What is the patient's date of birth?"
/>
</div>
<MaskedInput
  viewPath={`${viewPath}/MaskedInput`}
 autoFocus={true}
 mask="date"
 onChange={onChange}
 onSubmit={onSubmit}
 placeholder="mm/dd/yyyy"
 textTransform="none"
 type="text"
 initialValue={value}
/>
<Status
  viewPath={`${viewPath}/Status`}
 onSubmit={onSubmit}
/>
</div>
{children}
</React.Fragment>)
}